export default "__VITE_ASSET__68WyDxKj__"